import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WithLoadingPipe } from '../../../../util/pipes/with-loading-pipe';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { concat, Observable, of, Subject } from 'rxjs';
import { CompanySearchDto } from '../../../recovery/component/recovery-company/dto/CompanyWithOrgDto';
import { debounceTime, distinctUntilChanged, startWith, switchMap } from 'rxjs/operators';
import { CompanyBackendService } from '../../../pp/service/company-backend.service';
import { ERROR_IMAGE_LINK } from '../../../cabinet/component/cabinet/cabinet.component';
import { TextWithTooltipComponent } from "../../../../components/text-with-tooltip/text-with-tooltip.component";

@Component({
  standalone: true,
  selector: 'app-global-company-search',
  templateUrl: './global-company-search.component.html',
  styleUrls: ['./global-company-search.component.scss'],
  imports: [
    WithLoadingPipe,
    AsyncPipe,
    NgIf,
    NgForOf,
    TextWithTooltipComponent,
  ],
})
export class GlobalCompanySearchComponent implements OnInit {
  private searchTerms = new Subject<string>();
  @Input() fundNameMaxLength = 13; // maximal number of symbols in the fund name  ALSO change width of the DIV!!!
  @Output() selectedCompanyEmitter = new EventEmitter<CompanySearchDto>();

  @Input() set search(value: string) {
    this.searchTerm(value);
  }

  companies$: Observable<CompanySearchDto[]>;
  errorImageLink = ERROR_IMAGE_LINK;
  constructor(private companyService: CompanyBackendService) {
  }

  ngOnInit(): void {
    this.companies$ = this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      startWith(''),
      switchMap((term: string) => (!term ? of([]) :
        concat(of(undefined), this.companyService.getByNameSubstring(term)))),
    );
  }

  /**
   * Resets the form with selected company and period
   * and searches the companies from other orgs by substring.
   *
   * @param term is the substring of other company name.
   */
  searchTerm(term: string): void {
    setTimeout(() => {
      this.searchTerms.next(term);
    }, 0);
  }

}
